export class DashboartChartGenderModel {
    categories: any[] = [];
    maleData: any[] = [];
    femaleData: any[] = [];
    otherData: any[] = [];

    // constructor(categories: any[], maleData: any[], femaleData: any[], otherData: any[]) {
    //     this.categories = categories;
    //     this.maleData = maleData;
    //     this.femaleData = femaleData;
    //     this.otherData = otherData;
    // }
}